import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { API_BASE_URL } from "../config";

const placeholderImage = "/images/placeholder.png";

function Checkout() {
  const { id } = useParams();
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paymentComplete, setPaymentComplete] = useState(false);

  useEffect(() => {
   fetch(`${API_BASE_URL}/api/listings/${id}`)
      .then((res) => res.json())
      .then((data) => {
        setListing(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    if (!listing) return;

    const script = document.createElement("script");
    script.src = "https://www.paypal.com/sdk/js?client-id=YOUR_PAYPAL_CLIENT_ID&currency=AUD";
    script.addEventListener("load", () => {
      if (window.paypal) {
        window.paypal.Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [{ amount: { value: listing.price } }],
            });
          },
          onApprove: (data, actions) => {
            return actions.order.capture().then(async () => {
              // Call backend to verify payment
              try {
                const res = await fetch(`${API_BASE_URL}/api/verify-payment`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ orderId: data.orderID, listingId: listing.id }),
                });
                const result = await res.json();
                if (result.verified) setPaymentComplete(true);
                else alert("Payment could not be verified.");
              } catch (err) {
                console.error(err);
                alert("Error verifying payment.");
              }
            });
          },
          onError: (err) => {
            console.error(err);
            alert("Payment failed. Please try again.");
          },
        }).render("#paypal-button-container");
      }
    });
    document.body.appendChild(script);
  }, [listing]);

  const getImageSrc = (image) =>
    !image ? placeholderImage : image.startsWith("images/") ? `/${image}` : image;

  if (loading) return <p style={{ textAlign: "center", marginTop: "2rem" }}>Loading...</p>;
  if (!listing) return <p style={{ textAlign: "center", marginTop: "2rem" }}>Listing not found</p>;

  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px" }}>
      <Link to="/listings" style={{ textDecoration: "none", color: "#1976d2", marginBottom: "20px", display: "inline-block" }}>
        ← Back to Listings
      </Link>

      <h2 style={{ textAlign: "center", color: "#2e7d32", marginBottom: "30px" }}>Checkout</h2>

      {/* Listing Card */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        backgroundColor: "#fff",
        borderRadius: "15px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        overflow: "hidden",
        marginBottom: "30px"
      }}>
        <div style={{ flex: "1 1 300px", minHeight: "200px" }}>
          <img src={getImageSrc(listing.image)} alt={listing.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        </div>
        <div style={{ flex: "1 1 400px", padding: "30px", display: "flex", flexDirection: "column", gap: "10px" }}>
          <h3 style={{ fontSize: "1.5rem", color: "#2e7d32", marginBottom: "10px" }}>{listing.title}</h3>
          <p style={{ fontSize: "1.1rem" }}><strong>Price:</strong> ${listing.price}</p>
          {listing.clientHome === "No" && (
            <p style={{ color: "#2e7d32", fontWeight: "bold", fontSize: "1rem" }}>
              Client does NOT need to be home – flexible mowing times
            </p>
          )}
        </div>
      </div>

      {!paymentComplete ? (
        <div style={{
          backgroundColor: "#f0f7f1",
          padding: "25px",
          borderRadius: "15px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
          textAlign: "center"
        }}>
          <h3 style={{ marginBottom: "15px", color: "#2e7d32" }}>Pay with PayPal</h3>
          <div id="paypal-button-container"></div>
        </div>
      ) : (
        <div style={{
          backgroundColor: "#e6f3e8",
          padding: "25px",
          borderRadius: "15px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
          textAlign: "center"
        }}>
          <h3 style={{ color: "#2e7d32", marginBottom: "15px" }}>Payment Verified!</h3>
          <p style={{ fontSize: "1.1rem" }}>You can now contact the seller:</p>
          <p style={{ fontSize: "1.2rem", fontWeight: "bold" }}>{listing.contactMethod}</p>
          <Link to="/listings"
                style={{
                  display: "inline-block",
                  marginTop: "20px",
                  padding: "10px 25px",
                  backgroundColor: "#2e7d32",
                  color: "#fff",
                  borderRadius: "8px",
                  textDecoration: "none",
                  fontWeight: "bold"
                }}>
            Back to Listings
          </Link>
        </div>
      )}
    </div>
  );
}

export default Checkout;
